import { render, staticRenderFns } from "./ManagePackages.vue?vue&type=template&id=a371feaa&scoped=true&"
import script from "./ManagePackages.vue?vue&type=script&lang=js&"
export * from "./ManagePackages.vue?vue&type=script&lang=js&"
import style0 from "./ManagePackages.vue?vue&type=style&index=0&id=a371feaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a371feaa",
  null
  
)

export default component.exports